import React from "react";
import { useLang } from "@/context/LanguageContext";
import { SHOP } from "@/i18n/shop";

const STYLES = {
  AVAILABLE: "border-emerald-400/40 text-emerald-300/90",
  LIMITED: "border-amber-400/50 text-amber-300/90",
  SOLD_OUT: "border-white/20 text-white/50",
  PREORDER: "border-gold/50 text-gold",
};

// Shows ONLY a commercial state, never a numeric stock quantity.
export const AvailabilityBadge = ({ state, className = "", testid }) => {
  const { t } = useLang();
  const s = state && SHOP.availability[state] ? state : "AVAILABLE";
  return (
    <span
      data-testid={testid || `availability-${s}`}
      className={`inline-flex items-center gap-2 border px-3 py-1 text-[10px] uppercase tracking-widest ${STYLES[s]} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s === "SOLD_OUT" ? "bg-white/40" : s === "AVAILABLE" ? "bg-emerald-400" : s === "LIMITED" ? "bg-amber-400" : "bg-gold"}`} />
      {t(SHOP.availability[s])}
    </span>
  );
};
